import SingleModelInterface from '../../types/singleModelInterface'
import Specialization from './specialization'

export function shouldDisablePrivateTab(
    carsFilteredByDealer: SingleModelInterface[]
): boolean {
    return (
        !carsFilteredByDealer.some(
            (car) =>
                car.specialization === Specialization.PRODOTTI_LIFE ||
                car.specialization === Specialization.PRODOTTI_CAMPER
        ) ||
        carsFilteredByDealer
            .filter(
                (car) =>
                    car.specialization === Specialization.PRODOTTI_LIFE ||
                    car.specialization === Specialization.PRODOTTI_CAMPER
            )
            .every((car) => car.in_specialization === 0)
    )
}
